import React, {useEffect, useState} from 'react';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import moment from 'moment';


function NotificationContent(props) {
    const [fromName, setFromName] = useState('');
    const [toName, setToName] = useState('');
    const [textContent, setTextContent] = useState('');
    const [createdAt, setCreatedAt] = useState('');
    useEffect(()=>{
        getProfileData()
    },[]);
    const getProfileData = async()=> {
        if(props.item)
        {
            let content = JSON.parse(props.item.content);
            let to= content.find(i=>i.to);
            let from= content.find(i=>i.from);
            if(to)
            {
                setToName(to.to)
            }
            if(from)
            {
                setFromName(from.from)
            }
            
            let text = content.find(i=>i.text);
            setTextContent(text.text);
            setCreatedAt(props.item.createdAt)
            
        }

    }
  return (
    <>
        <ListItemText secondary={
            <React.Fragment>
                <Typography component="h3" variant="h3">{fromName}</Typography>
                <Typography component="p" variant="p">{textContent} {/*toName!='' ? toName :''*/}</Typography>
                <Typography component="span" variant="span">{moment(createdAt).fromNow()} </Typography>
            </React.Fragment>
        }/>
    </>
  )
}

export default NotificationContent